import { LMspecialHours, ListingSpecialHoursData } from "./types";

export const parseAPILMspecialHours = (apiLMspecialHours: ListingSpecialHoursData): LMspecialHours => {
  return {
    specialHoursData: apiLMspecialHours,
  }
}
